"use client";

import React from "react";

import Image from "next/image";
import DecorationLine from "@/components/global/ui/DecorationLine";
import { cn } from "@/lib/utils";
import { PortableText } from "@portabletext/react";
import { richTextComponent } from "@/sanity/sanityPortableText";

import { PageMentoringV2Schema } from "@/sanity/pages/PageMentoringV2Template";

export default function NumbersSection({ data, className }: { data: PageMentoringV2Schema; className?: string }) {
  return (
    <section className={cn("relative overflow-clip ", className)}>
      <DecorationLine
        className="hidden top-0 lg:block"
        orientation="vertical"
        position="left"
      />
      <DecorationLine
        className="hidden top-0 lg:block"
        orientation="vertical"
        position="right"
      />

      <div className="relative">
        <DecorationLine
          className="bottom-0"
          orientation="horizontal"
        />

        {data?.numbersItems && (
          <div className="grid grid-cols-1 lg:grid-cols-3 px-[1rem] sm:px-[3rem] lg:px-[7rem]">
            {data?.numbersItems.map((item, index) => (
              <div
                key={index}
                className="flex lg:flex-col items-center justify-start lg:justify-center gap-[3rem] lg:gap-[2rem] py-[2.5rem] lg:py-[5rem] relative pl-[12%] lg:pl-0">
                {item?.icon && (
                  <Image
                    className="!w-[7rem]"
                    src={item.icon}
                    alt=""
                  />
                )}

                {item?.text && (
                  <div className="richtext richtext-start lg:richtext-center prose-p:text-black/90 prose-em:leading-none prose-em:font-ivy prose-em:tracking-[0.3px] prose-em:font-light prose-em:text-[4rem] prose-em:text-black lg:prose-em:text-[5rem]">
                    <PortableText
                      value={item.text}
                      components={richTextComponent}
                    />
                  </div>
                )}

                {index < data.numbersItems.length - 1 && (
                  <>
                    <DecorationLine
                      className="hidden top-0 right-0 lg:block"
                      orientation="vertical"
                    />
                    <DecorationLine
                      className="bottom-0 left-0 lg:hidden"
                      orientation="horizontal"
                    />
                  </>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
